import React, { useCallback } from "react";
import { useAuth } from "../hooks/useAuth";
import { useNavigation, useFocusEffect, useRoute } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { RootStackParamList } from "../navigation/AppNavigator.web";
import { useAppConfig } from "../AppConfigProvider";

const noAuth = (WrappedComponent) => {
  const NoAuthComponent = (props) => {
    const { isUpdating, isAuthenticated, isEmailVerified, otpVerifiedForSession } = useAuth();
    const navigation = useNavigation<NativeStackNavigationProp<RootStackParamList>>();
    const route = useRoute();
    const appConfig = useAppConfig();

    const isCompanionMode = appConfig.isCompanionMode;
    const allowFormSignup = appConfig.allowFormSignup;

    useFocusEffect(
      useCallback(() => {
        if (!allowFormSignup && !isAuthenticated && route.name === "Signup") {
          navigation.reset({
            index: 0,
            routes: [{ name: "Login" }],
          });
        } else if (route.name === "Verify Email" && !isAuthenticated) {
          navigation.reset({
            index: 0,
            routes: [{ name: "Login" }],
          });
        } else if (isAuthenticated && isEmailVerified && otpVerifiedForSession) {
          navigation.reset({
            index: 0,
            routes: [isCompanionMode ? { name: "Companion" } : { name: "Home" }],
          });
        }
      }, [
        isAuthenticated,
        navigation,
        route.name,
        isCompanionMode,
        allowFormSignup,
        isEmailVerified,
        otpVerifiedForSession,
      ])
    );

    if (isUpdating) {
      return null;
    }

    return <WrappedComponent {...props} />;
  };

  return NoAuthComponent;
};

export default noAuth;
